export default {
  CURRENCY: process.env.CURRENCY,
  CONTACT_URL: process.env.CONTACT_URL,
  CURRENCY_CODE: "RM",
  CURRENCY_CODE_FOR_ORDER: "MYR",
  CURRENCY_FORMAT: 2, // 0.00
  CURRENCY_RGX: /(\d)(?=(\d\d\d)+(?!\d))/g,
  MAX_TOPPING: 2,
  MAX_REMOVE_TOPPING: 2,
  CURRENCY_DEC_POINT: "$1,",
  COUNTRY_CODE: "MY",
  HIDE_ORDER_SUMMARY: true,
  DOMAIN_STATIC: process.env.STATIC_URL,
  COUNTRY_CODE_COMPONENT: "country:my",
  GOOGLE_MAP_API_KEY: process.env.GOOGLE_MAP_API_KEY,
  TAX_RATE: 6,
  LIMIT_VIEW_MORE: 3,
  SHOW_POPUP_QR: false,
  PAYMENT_METHOD_MAYBANK_CREDIT_CARD: "soft_bank",
  PAYMENT_METHOD_CREDIT_CARD: "mpay_credit",
  PAYMENT_METHOD_MAYBANK2U: 5,
  PAYMENT_METHOD_CASH_ON_DELIVERY: 'cash',
  PAYMENT_METHOD_CREDIT_CARD_EGHLCREDIT: 'eghl_cc',
  PAYMENT_METHOD_APPLE_PAY: 'razer_e_apple',
  PAYMENT_METHOD_FOR_CASH_ON_DELIVERY: 1,
  PAYMENT_METHOD_MASTERPASS: 4,
  COPY_RIGHT: "Copyright",
  COPY_RIGHT_MK: "PIZZA HUT MALAYSIA. All Rights Reserved.",
  CYBERSOURCE_PAYMENT_URL: process.env.CYBERSOURCE_PAYMENT_URL,
  TEL: "89111111",
  GEO: {
    POSITION: {
      LAT: 4.210484,
      LNG: 101.975766
    }
  },
  LIMIT_SHOW_PAYMENT: 5,
  LIMIT_BIRTHDAY: 1900,
  MENU_DEAL: 'promos',
  MENU_DEFAULT: 'promos',
  MENU_LUNCH: 'lunch-time',
  MENU_HUT_DAY: 'hut-day',
  MENU_PIZZA: 'pizzas',
  MENU_COUPON: 'coupons',
  DELIVERY: 'DELIVERY',
  CARRYOUT: 'CARRYOUT',
  DEFAULT_CONFIG_APP: 'MAP',
  DEFAULT_CONFIG_APP_2: 'Localization',
  OPEN_TIME: '10:00:00',
  CLOSE_TIME: '23:00:00',
  URL_JP: '/pc/shop_detail/',
  FULL_URL_JP: 'https://pizzahut.jp/pc/shop_detail/',
  DOMAIN_BETA: 'phjbeta.phdvasia.com',
  SWIFTYPE_HOST: 'host-eypj92',
  SWIFTYPE_API_KEY: 'search-vksfirz45gsd5mq9vvd17nry',
  SWIFTYPE_ENGINE_NAME: 'phjjp',
  NUM_OF_COUNTRY_CODE: '2',
  HALF_HALF_ID: 2,
  HALF_HALF_SET: {
    NORMAL: 0,
    LUNCH: 1,
    BOTH: 2
  },
  HALF_HALF_PRICE: 1800,
  HALF_HALF_LUNCH_PRICE: 1300,
  CARD_ITEM_TYPE: { SINGLE: 0, COMBO: 1, HALF: 2 },
  LUNCH_TIME_UUID: "48609434-44bc-3a02-9e23-d682dcbf4395",
  HALF_HALF_UUID: "half-and-half",
  HALF_HALF_LUNCH_UUID: "lunch-half-and-half",
  COUPON_UUID: "6d7faa2c-5cf4-11e9-8647-d663bd873d93",
  VOUCHER_UUID: "6444a9dc-f4fa-470c-809a-a5cc35d3f2f3",
  FACEBOOK_LOGIN: 1, // login with facebook
  GOOGLE_LOGIN: 2, // login with google +
  YAHOO_LOGIN: 3, // login with yahoo
  HUT_DAY_UUID: "8ff881a5-6cc1-4661-a678-bcf1e6e516bb",
  CATEGORY_TOPIC: "campaigns",
  CATEGORY_COUPON: "coupons",
  CATEGORY_COUPON_URI: "/order/coupons",
  DISCOUNT_EXCLUDE_ITEM: 'CP-36',
  REQUIRE_ITEM_INFO: 'CP-41',
  COUPON_ALLOW: {
    "CP-02": {},
    "CP-03": { fields: ["min_cart"], currency: true },
    "CP-04": {},
    "CP-05": {},
    "CP-07": {},
    "CP-08": {},
    "CP-09": {},
    "CP-10": {},
    "CP-11": {},
    "CP-12": {},
    "CP-13": {},
    "CP-16": {},
    "CP-17": {},
    "CP-18": { fields: ["day_of_weeks"] },
    "CP-19": {},
    "CP-20": {},
    "CP-21": {},
    "CP-22": {},
    "CP-23": {},
    "CP-24": {},
    "CP-25": { fields: ["min_cart"] }
  },
  CART_CODE: {
    INVALIDHUTDAY: "ITEM-02",
    NOTFOUND: "CART-01",
    INVALIDLUNCHTIME: "ITEM-03",
    SELLINGTIME: "SINGLE-06",
    INVALIDORDERTIME: "HUT-01",
    INVALIDOPENTIME: "HUT-02",
    INVALIDMINCART: "CART-03",
    EMPTYCART: "CART-04",
    INVALIDCURRENTORDERTIME: "CART-07",
    SEVICEUNAVAILABLEDELIVERY: "HUTFE-19",
    SEVICEUNAVAILABLEPICKUP: "HUTFE-20",
    OPENING_NOT_FOUND: "HUTFE-4",
    CART_EMPTY_ADD_ON: "ITEM-10",
  },  
  PAYMENT_COUPON_ERROR: ["CP-14"],
  GMS_EXCEPTION_CODE: ["CP-03"],
  MESSAGES_PARAMS: {
    "CP-18": { fields: ["day_of_weeks"] }
  },
  MESSAGES: {
    "ORDER-0": "order.error_text_item_invalid",
    "ORDER-1": "order.error_text_order_not_found",
    "ORDER-2": "order.error_text_empty_cart_detail",
    "ORDER-3": "order.error_text_empty_store_detail",
    "ORDER-4": "order.error_text_single_invalid",
    "ORDER-5": "order.error_text_not_update_use_coupon",
    "ORDER-6": "order.error_text_apply_coupon_fail",
    "ORDER-7": "order.error_text_not_add_item_cart",
    "ORDER-8": "order.error_text_not_create_cart",
    // 'ORDER-9': 'order.error_text_invalid_order_time',
    "ORDER-10": "order.error_text_empty_store_open_time",
    "ORDER-11": "order.error_text_invalid_collection_time",
    "ORDER-12": "order.error_text_store_close",
    COMMON: "cart.error_text_invalid_cart_item",
    "HUT-01": "cart.error_text_invalid_order_time",
    "HUT-02": "cart.error_text_invalid_open_time",
    "HUT-03": "cart.error_text_invalid_res_info",
    "HUT-04": "cart.error_text_call_hut_api_error",
    "CART-01": "cart.error_text_cart_not_found",
    "CART-02": "cart.error_text_invalid_time_quote",
    "CART-03": "cart.error_text_invalid_min_cart",
    "CART-04": "cart.error_text_empty_cart",
    "CART-05": "cart.error_text_invalid_outlet_min",
    "CART-07": "cart.error_text_invalid_curr_order_time",
    "REWARD-01": "cart.dont_have_coupon",
    "REWARD-02": "cart.coupon_dont_contain_coupon",
    "REWARD-03": "cart.can_not_get_coupon",
    "REWARD-04": "cart.invalid_reward_item",
    "REWARD-05": "cart.coupon_expired",
    "ITEM-02": "cart.invalid_hutday",
    "ITEM-03": "cart.invalid_lunchtime",
    "ITEM-04": "cart.invalid_reward_item",
    "COMBO-01": "cart.invalid_combo_uuid",
    "COMBO-02": "cart.invalid_combo_response",
    "COMBO-03": "cart.invalid_selling_date",
    "GROUP-01": "cart.invalid_group_id",
    "GROUP-02": "cart.invalid_item_id",
    "GROUP-03": "cart.invalid_second_id",
    "GROUP-04": "cart.invalid_topping",
    "GROUP-05": "cart.invalid_first_id",
    "SINGLE-01": "cart.invalid_product_id",
    "SINGLE-02": "cart.invalid_single_response",
    "SINGLE-03": "cart.invalid_second_id",
    "SINGLE-04": "cart.invalid_topping",
    "SINGLE-05": "cart.invalid_first_id",
    "SINGLE-06": "cart.invalid_selling_date",
    "SINGLE-07": "cart.invalid_open_time",
    "COUPON-01": "cart.invalid_coupon",
    "COUPON-02": "cart.broken_coupon_link",
    "COUPON-03": "cart.invalid_coupon_apply",
    "COUPON-04": "cart.invalid_payment_method",
    "CUS-100001": "customer.token_invalid",
    "CUS-100002": "customer.customer_not_found",
    "CUS-100003": "customer.email_exist",
    "CUS-100004": "customer.can_not_create",
    "CUS-100005": "customer.can_not_update",
    "CUS-100006": "customer.auth_fail",
    "CUS-100007": "customer.using_old_password",
    "CUS-100008": "customer.can_not_create_location",
    "CUS-100009": "customer.can_not_update_location",
    "CUS-100010": "customer.otp_sent",
    "CUS-100011": "customer.opt_invalid",
    "CUS-100012": "customer.request_id_invalid",
    "CUS-100013": "customer.otp_required",
    "CUS-100014": "customer.data_invalid",
    "CUS-100015": "customer.email_id_not_found",
    "CUS-100016": "customer.can_not_create_contact",
    "CUS-100017": "customer.location_notfound",
    "CUS-100022": "validate_invalid_password",
    "CUS-100023": "validate_password_no_uppercase",
    "CUS-100024": "validate_password_no_lowercase",
    "CUS-100025": "validate_password_no_number",
    "CUS-100026": "validate_password_no_non_alphanumberic",
    "CP-01": "coupon.exception",
    "CP-02": "coupon.already_apply",
    "CP-03": "coupon.minimun_amount_apply",
    "CP-04": "coupon.invalid_open_time",
    "CP-05": "coupon.invalid_order_type",
    "CP-06": "coupon.invalid_sale_channel",
    "CP-07": "coupon.login_to_use",
    "CP-08": "coupon.invalid_this_user",
    "CP-09": "coupon.invalid_this_outlet",
    "CP-10": "coupon.invalid_multiple",
    "CP-11": "coupon.invalid_with_menu_item",
    "CP-12": "coupon.coupon_not_found",
    "CP-13": "coupon.invalid_order_time",
    "CP-15": "coupon.missing_params_validation",
    "CP-16": "coupon.quality_not_sufficient",
    "CP-17": "coupon.only_future",
    "CP-18": "coupon.only_weekday",
    "CP-19": "coupon.only_hut_day",
    "CP-20": "coupon.only_lunctime",
    "CP-21": "coupon.item_not_applicable",
    "CP-22": "coupon.invalid_min_amount_apply_coupon",
    "CP-23": "coupon.invalid_limit_coupon",
    "CP-24": "coupon.coupon_cp_24",
    "CP-25": "coupon.minimun_item",
    "CP-31": "coupon.applicable_shopee",
    'CP_33': 'COUPON_CP_33',
    "CPH-01": "coupon.history_exception",
    "CPH-02": "coupon.missing_params_history",
    "GA-01": "coupon.game_unavailable",
    "GA-02": "coupon.game_setting_empty",
    "GA-03": "coupon.game_exceeded_play_time",
    "HUTFE-10": "localization.notopen",

    "HUTFE-0": "hutfe.error_text_fe_invalid_input_data",
    "HUTFE-1": "hutfe.error_text_fe_store_not_found",
    "HUTFE-2": "hutfe.error_text_fe_order_time_in_past",
    "HUTFE-3": "hutfe.error_text_fe_info_accurate",
    "HUTFE-4": "hutfe.error_text_fe_temporarily_unavailable",
    "HUT-FE-004": "hutfe.error_text_fe_opentimes",
    "HUTFE-5": "hutfe.error_text_fe_service_end",
    "HUTFE-6": "hutfe.error_text_fe_address_code_not_found",
    "HUTBE-1": "hutbe.error_text_be_store_not_found",
    "HUTBE-2": "hutbe.error_text_be_store_group_not_found",
    "HUTBE-3": "hutbe.error_text_be_file_invalid",
    "HUTBE-4": "hutbe.error_text_be_store_id_invalid",
    "HUTBE-5": "hutbe.error_text_be_select_file",
    "HUTBE-6": "hutbe.error_text_be_file_not_found",
    "HUTBE-7": "hutbe.error_text_be_temporarily_unavailable",
    "HUTBE-8": "hutbe.error_text_be_service_end",
    "HUTBE-9": "hutbe.error_text_be_call_internal_error",
    "HUTBE-0": "hutbe.error_text_be_invalid_data",
    "HUTFE-19": "hutbe.error_text_fe_delivery_temporarily_unavailable",
    "HUTFE-20": "hutbe.error_text_fe_pickup_temporarily_unavailable"
  },
  MESSAGES_CODE: {
    INCREASE_TIME: ["warning-001", "warning-002", "warning-003", "warning-004"],
    STOP_DELIVERY_WITHOUT_TIME_RANGE_HAS_REASON: [
      "HUTFE-19",
      "HUTFE-19-001",
      "HUTFE-19-002",
      "HUTFE-19-003",
      "HUTFE-19-004"
    ],
    STOP_DELIVERY_TOTAL: [
      "HUTFE-10",
      "HUTFE-10-001",
      "HUTFE-10-002",
      "HUTFE-10-003",
      "HUTFE-10-004"
    ],
    STOP_TOTAL_WITH_TIMEOUT_RANGE: [
      "HUTFE-25",
      "HUTFE-25-001",
      "HUTFE-25-002",
      "HUTFE-25-003",
      "HUTFE-25-004"
    ],
    STOP_TOTAL_WITH_TIME_RANGE: [
      "HUTFE-9-001",
      "HUTFE-9-002",
      "HUTFE-9-003",
      "HUTFE-9-004"
    ]
  },
  LOCALIZATION_CODE: {
    UNAVALIABLE: 'HUTFE-4',
    NOTOPEN: 'HUTFE-10',
    STORECLOSE: 'HUTFE-5',
    CLOSESTORE: 'HUT-FE-5',
    HUT19 : 'HUTFE-19',
    HUT20 : 'HUTFE-20',
    STORE_INACTIVE: 'HUTFE-1',
    /*ONLY FOR DEAD TRACKING*/
    DELIVERY_DEADZONE : [
      'HUTFE-19',
      'HUTFE-19-001',
      'HUTFE-19-002',
      'HUTFE-19-003',
      'HUTFE-19-004',
      'HUTFE-16',
      'HUTFE-14'
    ],
    HUT_CLOSED : [
      'HUTFE-25-001',
      'HUTFE-25-002',
      'HUTFE-25-003',
      'HUTFE-25-004',
      'HUTFE-25'],
    HUT_BOUNCING : ['HUTFE-10', 'HUTFE-5']
    /*END DEAD TRACKING*/
  },
  CUSTOMER_CODE: {INVALID: 'CUS-100001', NOT_FOUND: 'CUS-100002'},
  CUSTOMER_INVALID: ['CUS-100002', '100002', 'PAYMENT-100002'],
  COUPON_CODE: {TOKEN_INVALID: 'CP-24'},
  COUPON_TYPE_ITEM: 1,
  COUPON_TYPE_UNIT: 2,
  COUPON_TYPE_PERCENT: 3,
  COUPON_TYPE_FREE_DELIVERY: 4,
  IMG_PIZZA_DEFAULT:
    "https://fcds-jpdev.s3.ap-northeast-1.amazonaws.com/static/img/1.png",
  IMG_CRUST_DEFAULT:
    "https://fcds-jpdev.s3.ap-northeast-1.amazonaws.com/static/img/2.PNG",
  FLAG_DELIVERY_FEE: true,
  COUPON_PAGE_REQUIRED_LOGIN: true,
  LANG_JP: "ja",
  LANG_EN: "en",
  LANG_ARABIC: "es",
  LANG_MALAY: "as",
  LANG_NEWZEALAND: "mi",
  DATA_LAYER: {
    PLATFORM: {
      type: "website",
      name: "phdv",
      environment: "",
      localeRegion: "apac",
      localeCountry: "MYR",
      localeLanguage: "en",
      currency: "RM"
    }
  },
  DEFAULT_SELECTED_BIRTH_YEAR: 20,
  HEADER_MENU: {
    CAMPAIGN: "campaigns",
    CAMPAIGN_DETAIL: "campaign-detail",
    TOPIC: "topic",
    TOPIC_DETAIL: "topic-detail",
    CATEGORY: "category",
    COUPON: "coupons",
    HALF_HAlF: "half-half",
    PIZZA: "pizzas",
    LUNCH_SET: "lunch-set",
    COMBO_DETAIL: "combo-detail",
    VOUCHER: "vouchers"
  },
  PIZZA_SLUG: ["pizzas", "pizza"],
  ORDER_STATUS: {
    ERROR: [4, 22],
    STARTING: [1, 2, 25, 27],
    RECEIVED: [3, 10, 11, 12, 13, 14, 15],
    COOKING: [5],
    DELIVERING: [6],
    COMPLETED: [7, 9],
    CANCELED: [8]
  },
  ORDER_STATUS_IMAGE: {
    ERROR: [4, 22],
    STARTING: {
      GIF: process.env.STATIC_URL + "/icons/tracker-ani_01-chosen-alpha.gif",
      PNG: process.env.STATIC_URL + "/icons/tracker-ani_01-chosen-alpha.png"
    },
    RECEIVED: {
      GIF:
        process.env.STATIC_URL +
        "/icons/driver_tracker/tracker-ani_02-no-currency-accepted-alpha.gif",
      PNG: process.env.STATIC_URL + "/icons/driver_tracker/accepted.png"
    },
    COOKING: {
      GIF:
        process.env.STATIC_URL +
        "/icons/driver_tracker/tracker-ani_03-making-alpha.gif",
      PNG: process.env.STATIC_URL + "/icons/driver_tracker/making.png"
    },
    DELIVERING: {
      GIF:
        process.env.STATIC_URL +
        "/icons/driver_tracker/tracker-ani_05-delivery-alpha.gif",
      PNG: process.env.STATIC_URL + "/icons/driver_tracker/delivery.png"
    },
    COMPLETED: {
      GIF: process.env.STATIC_URL + "/icons/tracker-collection.gif",
      PNG: process.env.STATIC_URL + "/icons/tracker-collection.png"
    },
    CANCELED: {
      GIF: process.env.STATIC_URL + "/icons/tracker-ani_01-chosen-alpha.gif",
      PNG: process.env.STATIC_URL + "/icons/tracker-ani_01-chosen-alpha.png"
    },
    READY: {
      GIF: process.env.STATIC_URL + "/icons/tracker-collection.gif",
      PNG: process.env.STATIC_URL + "/icons/tracker-collection.png"
    }
  },
  PHONE_MIN_LENGTH: 8,
  PHONE_MAX_LENGTH: 11,
  PHONE_PREFIX: ["020", "021", "022", "027", "029"],
  COUPON_TYPES: {
    PROMOTION: [4, 5, 6],
    DISCOUNT: [2, 3],
    FREE_GIFT: [1],
    CIRCLE_DISCOUNT: [5]
  },
  COUPON_IMAGES: {
    PROMOTION: {
      JA: process.env.STATIC_URL + "/images/Promotion-JP.jpg",
      EN: process.env.STATIC_URL + "/images/Promotions.png"
    },
    DISCOUNT: {
      JA: process.env.STATIC_URL + "/images/Discount-JP.jpg",
      EN: process.env.STATIC_URL + "/images/Discount.png"
    },
    FREE_GIFT: {
      JA: process.env.STATIC_URL + "/images/Free-Gift-JP.jpg",
      EN: process.env.STATIC_URL + "/images/Free Gift.png"
    }
  },
  QUOTE_TIME_CARRYOUT: 30,
  EVENT_BUS: {
    LOADING: "LOADING",
    LOAD_CATEGORY: "LOAD_CATEGORY",
    SHOW_ASAP: "SHOW_ASAP",
    REDIRECT_TO_MENU_PAGE: "REDIRECT_TO_CATEGORY_PAGE",
    SHOW_MODAL_DELIVERY: "SHOW_MODAL_DELIVERY",
    SHOW_MODAL_PICKUP: "SHOW_MODAL_PICKUP"
  },
  TOPPING: {
    MAX_TOPPING: process.env.MAX_TOPPING,
    MAX_PER_TOPPING: process.env.MAX_PER_TOPPING,
    TYPE_DEFAULT: 1,
    TYPE_EXTRA: 2
  },
  HALF_HALF_IMAGES: {
    NORMAL_4: process.env.STATIC_URL + "/images/half-and-half.png",
    NORMAL_2: process.env.STATIC_URL + "/images/half-and-half-2.jpg",
    LUNCH_4: process.env.STATIC_URL + "/images/Lunch_H&H.png",
    LUNCH_2: process.env.STATIC_URL + "/images/Lunch_H&H_BG.jpg",
    CATEGORY: process.env.STATIC_URL + "/images/half_half_category.png"
  },
  IMAGES: {
    HOME_CARD: process.env.STATIC_URL + "/images/home-cards2.png",
    HOME_TEXT_TOP:
      process.env.STATIC_URL +
      "/backgrounds/our-new-site-is-here-order-now.png",
    HUT_TEXT_1: process.env.STATIC_URL + "/store/Notification_fr_store.png",
    HUT_TEXT_2: process.env.STATIC_URL + "/store/Add_and_phone.png",
    HUT_TEXT_3: process.env.STATIC_URL + "/store/Buz_time.png",
    HUT_TEXT_4: process.env.STATIC_URL + "/store/Huts_day.png",
    COUPON_POPUP_EN: process.env.STATIC_URL + "/images/coupon-popup-en.png",
    COUPON_POPUP_JP: process.env.STATIC_URL + "/images/coupon-popup-jp.png"
  },
  HALF_HALF_EXCLUDE_STORE: [],
  NON_LOCALIZATION_CATEGORY: ["hot-deal"],
  SLUG_LIST: {
    PIZZA: ["pizza", "pizzas"],
    DEAL: ["hot-deal", "deals", "promos"]
  },
  SINGLE_TYPE_NAME: {
    BIG_NEWYORKER_RANGE: {
      KEY: "bignewyorker",
      VAL: "Big New Yorker Range"
    },
    DELUXE: {
      KEY: "deluxe",
      VAL: "Deluxe"
    },
    FAVOURITES: {
      KEY: "favourites",
      VAL: "Favourites"
    },
    CLASSIC: {
      KEY: "classic",
      VAL: "Classic Value"
    },
    REGULAR: {
      KEY: "newregularpizza",
      VAL: "Regular"
    }
  },
  FORMAT_CODE: {
    UTF8: "utf-8",
    JIS: "shift-jis"
  },
  TIMEOUT_CART: process.env.TIMEOUT_CART,
  ITEM_VIEW_MODE: 1, // 0 : DEFAULT , 1 : ONE TAP (AVAILABLE WITH NZ AND SG MARKET),
  COMBO_PRICE_VIEW_MODE: 1, // 0 : DEFAULT, 1 : SHOW BOTH [DISPLAY PRICE] AND [PRICE]
  CATEGORY_ITEM_VIEW_MODE: process.env.CATEGORY_ITEM_VIEW_MODE,
  LOCALIZATION_TYPE: process.env.LOCALIZATION_TYPE,
  LOCALIZATION_TYPES: {
    MAP: "MAP",
    MAP_ASIA: "MAP_ASIA",
    MAP_GOOGLE_API: "MAP_GOOGLE_API"
  },
  DEFAULT_LANGUAGE: process.env.DEFAULT_LANGUAGE,
  CLIENT_ID: process.env.CLIENT_ID,
  GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
  LANGUAGES: {
    en: {
      image: require("@/assets/images/icons/en.png"),
      text: "English"
    },
    ja: {
      image: require("@/assets/images/icons/jp.png"),
      text: "日本語"
    },
    ae: {
      image: require("@/assets/images/icons/jp.png"),
      text: "AE"
    }
  },
  EFTPOS_UUID: "326698d5-369b-4594-9571-f745b474ba4f",

  EFTPOS_CODE: "eftpos",
  IGNORGE_CRUST_ID: 6,
  KEY_UPSELL: "Upsell",
  NUMBER_OF_SHOW_POPUP_UPSELL: 0,
  NON_NOTIFY: ["payment-status"],
  OLD_PASSWORD_MIN: 6,
  PASSWORD_MIN: 8,
  CHARSET_RULE:
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789~!@#$%^&*_-+=`|\\(){}[]:;“’<>,.?/",
  COMBOGROUP_SEQUENCE_ID: {
    3: 1, //3-Classic
    5: 2, //5-Regular
    1: 3, //1-Favourites
    2: 4, //2-Delux
    8: 5, //8-pickup deal
    6: 7, //6-Delivery Deals
    7: 8 //7-Catering Deals
  },
  NAME_SEO_DEFAULT_CHEESE: "Default Cheese",
  SKU_DEFAULT_TOPPING: "DEFAULT",
  TOPPING_TYPE: [
    {
      TOPPING_TYPE_ID: 1,
      TOPPING_TYPE_NAME: "Meat"
    },
    {
      TOPPING_TYPE_ID: 2,
      TOPPING_TYPE_NAME: "Vegetables"
    },
    {
      TOPPING_TYPE_ID: 3,
      TOPPING_TYPE_NAME: "Extra"
    }
  ],
  NUM_OF_MAX_PER_TOPPING: 999,
  PREFIX_PHONE: [{ name: "60", value: "+60" }],
  DEFAULT_PREFIX_PHONE: "+60",
  PHONE_LENGTH_MIN: 8,
  PHONE_LENGTH_MAX: 11,
  CORONA_LESS_CONTACT_CONTENT: 'CONTACTLESS',
  SIZE_RESTRICT_TOPPING: ['PER'],
  HUT_REWARD_POINT: 3,
  CUSTOMER_SERVICE_PHONE: "1300-88-2525",
  HUT_REWARD_MENU_TYPE: 4,
  FREE_ITEM_MENU_TYPE: 5,
  DOMAIN_SG_S3: "https://static.phdvasia.com/my",
  SMARTECH: {
    CREATE: process.env.SMARTECH_CREATE,
    REGISTER: process.env.SMARTECH_REGISTER
  },
  CODE_WEB_MESSAGE: "IN-WEB",
  MAINTAIN_CODE_TITLE: "WEB-MAINTAIN-TITLE",
  CODE_APP_MESSAGE: "In-App",
  MAINTAIN_CODE_MESSAGE: "WEB-MAINTAIN-MESSAGE",
  DATA_BREADCRUMB: {
    login:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Log In</li>',
    signup:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Sign Up</li>',
    find_a_hut:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Location Finder</li>',
    hut_rewards:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Hut Rewards</li>',
    tracking:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Order and Delivery Status Checker</li>',
    order_beverages:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Beverages and Drinks</li>',
    order_coupons:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Coupon Code</li>',
    order_pastas:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Pasta and Spaghetti</li>',
    order_pizzas:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Pizzas</li>',
    order_sides:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Sides Menu</li>',
    order_promos:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li>Promotions and Deals</li>',
    order_promos_bigbox:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li><a href="https://www.pizzahut.com.my/order/promos">Promotions and Deals</a></li><li>Big Box</li>',
    order_promos_doublebox:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li><a href="https://www.pizzahut.com.my/order/promos">Promotions and Deals</a></li><li>Double Box</li>',
    order_promos_mybox:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li><a href="https://www.pizzahut.com.my/order/promos">Promotions and Deals</a></li><li>My Box</li>',
    order_promos_onthegocombos:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li><a href="https://www.pizzahut.com.my/order/promos">Promotions and Deals</a></li><li>On The Go Combos</li>',
    order_promos_wowpromo:
      '<li><a href="https://www.pizzahut.com.my">Home</a></li><li><a href="https://www.pizzahut.com.my/order/promos">Promotions and Deals</a></li><li>WOW Promo</li>'
  },
  DATA_JSONLD: {
    login: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Log In"
        }
      ]
    },
    signup: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Sign Up"
        }
      ]
    },
    find_a_hut: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Location Finder"
        }
      ]
    },
    hut_rewards: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Hut Rewards"
        }
      ]
    },
    tracking: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Order and Delivery Status Checker"
        }
      ]
    },
    order_beverages: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Beverages and Drinks"
        }
      ]
    },
    order_coupons: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Coupon Code"
        }
      ]
    },
    order_pastas: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Pasta and Spaghetti"
        }
      ]
    },
    order_pizzas: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Pizzas"
        }
      ]
    },
    order_sides: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Sides Menu"
        }
      ]
    },
    order_promos: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Promotions and Deals",
          item: "https://www.pizzahut.com.my/order/promos"
        }
      ]
    },
    order_promos_bigbox: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Promotions and Deals",
          item: "https://www.pizzahut.com.my/order/promos"
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Big Box"
        }
      ]
    },
    order_promos_doublebox: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Promotions and Deals",
          item: "https://www.pizzahut.com.my/order/promos"
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Double Box"
        }
      ]
    },
    order_promos_mybox: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Promotions and Deals",
          item: "https://www.pizzahut.com.my/order/promos"
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "My Box"
        }
      ]
    },
    order_promos_onthegocombos: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Promotions and Deals",
          item: "https://www.pizzahut.com.my/order/promos"
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "On The Go Combos"
        }
      ]
    },
    order_promos_wowpromo: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.pizzahut.com.my"
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Promotions and Deals",
          item: "https://www.pizzahut.com.my/order/promos"
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "WOW Promo"
        }
      ]
    }
  },
  PAGE_NOT_REMOVE_DISPOSITION: [
    "hut-rewards",
    "signup",
    "login",
    "logout",
    "checkout",
    "vouchers",
    "tracker-order-voucher"
  ],
  ONE_LINK: "https://m3vsv.app.link/A4XlYmxwXPb",
  DEFAULT_CONFIG_AB_TESTING: {
    environment: "browser",
    storage: "localStorage",
    storagePrefix: "test",
    onSetExperiment: (experimentGoal, experimentName, variantTitle) => {}
  },
  AB_TESTING_FUNCTIONAL: [
    {
      name: "homeLayout",
      goal: "CVR",
      expiry: "2021-04-04",
      variants: [
        {
          title: "oldHomePage",
          value: 1
        },
        {
          title: "newDesign",
          value: 2
        },
        {
          title: "hideAndMoveBanner",
          value: 3
        }
      ]
    },
    {
      name: 'paymentOnCart',
      goal: 'CVR',
      expiry: '2022-01-01',
      variants: [
        {
          title: 'showPayment',
          value: '1'
        },
        {
          title: 'notShowpayment',
          value: '0'
        }
      ]
    },
    {
      name: "lastOrder",
      goal: "CVR",
      expiry: "2022-01-01",
      variants: [
        {
          title: "alwaysShow",
          value: "1"
        },
        // {
        //   title: "notShow",
        //   value: "0"
        // }
      ]
    },
    {
      name: 'newDisposition',
      goal: 'CVR',
      expiry: '2023-04-04',
      variants: [
        {
          title: 'clickToOpenPopup',
          value: 1
        },
        {
          title: 'openAfterRedirectToMenu',
          value: 2
        },
        {
          title: 'openAfter5Seconds',
          value: 3
        },
      ]
    }
  ],
  CONTACT_CATEGORIES: [
    { value: "8", label: "Cleanliness" },
    { value: "9", label: "Hospitality" },
    { value: "10", label: "Accuracy of Order" },
    { value: "11", label: "Maintenance" },
    { value: "12", label: "Product Quality" },
    { value: "13", label: "Speed of Service" },
    { value: "14", label: "Compliment" },
    { value: "20", label: "Contest" },
    { value: "16", label: "Sponsorship" },
    { value: "17", label: "Suggestion" },
    { value: "18", label: "E-Commerce Issues" },
    { value: "19", label: "Promo" },
    { value: "15", label: "Other Complains" },
    { value: "21", label: "General Enquiries" }
  ],
  CONTACT_TIMES: [
    { value: "119", label: "Mid morning (10 am - 12 pm)" },
    { value: "120", label: "Lunch (12 pm - 2pm)" },
    { value: "121", label: "Afternoon (2 pm - 6pm)" },
    { value: "122", label: "Dinner ( 6 pm - 9pm)" },
    { value: "123", label: "After dinner (9 pm-12midnite)" }
  ],
  CONTACT_TYPE_VISITS: [
    { value: "124", label: "Dine In" },
    { value: "125", label: "Take Away" },
    { value: "126", label: "Pick up – Call In" },
    { value: "127", label: "Pick up - Online" },
    { value: "128", label: "Delivery- Call In" }
  ],
  CONTACT_STATES: [
    { value: "129", label: "Johor" },
    { value: "130", label: "Kedah" },
    { value: "131", label: "Kelantan" },
    { value: "132", label: "Melaka" },
    { value: "133", label: "Negeri Sembilan" },
    { value: "134", label: "Pahang" },
    { value: "135", label: "Perak" },
    { value: "136", label: "Perlis" },
    { value: "137", label: "Pulau Pinang" },
    { value: "138", label: "Sabah" },
    { value: "139", label: "Sarawak" },
    { value: "140", label: "Selangor" },
    { value: "141", label: "Terengganu" },
    { value: "142", label: "WP Kuala Lumpur" },
    { value: "143", label: "WP Labuan" },
    { value: "144", label: "WP Putrajaya" }
  ],
  CONTACT_OUTLETS: [
    { label: "PHD PANDAN JAYA", value: 142 },
    { label: "PHD JALAN PAHANG", value: 142 },
    { label: "PHD JALAN IMBI", value: 142 },
    { label: "PHD SRI BANGI", value: 140 },
    { label: "PHD KOTA WARISAN", value: 140 },
    { label: "PHD PJ OLD TOWN", value: 140 },
    { label: "PH EAST COAST MALL", value: 134 },
    { label: "PH GIANT KUANTAN", value: 134 },
    { label: "PH JERANTUT", value: 134 },
    { label: "PH KUANTAN PARADE", value: 134 },
    { label: "PH MEGAMALL KUANTAN", value: 134 },
    { label: "PH MENTAKAB", value: 134 },
    { label: "PH TEMERLOH", value: 134 },
    { label: "PH KUANTAN CITY MALL", value: 134 },
    { label: "PHD E-MART", value: 139 },
    { label: "PHD SERIAN", value: 139 },
    { label: "PHD LKC", value: 139 },
    { label: "PHD BATU KAWA", value: 139 },
    { label: "PHD SARIKEI", value: 139 },
    { label: "PHD MYDIN VISTA TUNKU", value: 139 },
    { label: "FCD EASTCOMM2,SIBURAN", value: 139 },
    { label: "PHD PUTATAN", value: 138 },
    { label: "PHD SEPANGGAR", value: 138 },
    { label: "PHD TUARAN", value: 138 },
    { label: "PHD KINGFISHER", value: 138 },
    { label: "PHD SANDAKAN PRIMA", value: 138 },
    { label: "PHD PAPAR", value: 138 },
    { label: "PHD KOTA MARUDU", value: 138 },
    { label: "FCD BUNDUSAN", value: 138 },
    { label: "PHD BANDAR KINRARA", value: 140 },
    { label: "PHD PUCHONG UTAMA", value: 140 },
    { label: "PHD PUCHONG JAYA", value: 140 },
    { label: "PHD USJ 9", value: 140 },
    { label: "PHD SUNWAY MENTARI", value: 140 },
    { label: "PHD BUKIT GAMBIR", value: 129 },
    { label: "PHD GELANG PATAH", value: 129 },
    { label: "PHD MUAR", value: 129 },
    { label: "PHD TAMAN PERLING", value: 129 },
    { label: "PHD TUN AMINAH", value: 129 },
    { label: "PHD PULAI PERDANA", value: 129 },
    { label: "PHX RSA PAGOH", value: 129 },
    { label: "FCD ANJUNG NUSAJAYA", value: 129 },
    { label: "PH AEON SERI MANJUNG", value: 135 },
    { label: "PH KAMPAR", value: 135 },
    { label: "PH SITIAWAN", value: 135 },
    { label: "PH TELUK INTAN", value: 135 },
    { label: "PH TANJUNG MALIM", value: 135 },
    { label: "PH EQUINE PARK", value: 140 },
    { label: "PH JUSCO CHERAS SELATAN", value: 142 },
    { label: "PH PUCHONG PRIMA", value: 140 },
    { label: "PH SG BESI", value: 142 },
    { label: "PH KUCHAI LAMA", value: 142 },
    { label: "FCD PARKLANE OUG", value: 142 },
    { label: "FCD LE PAVILLION", value: 140 },
    { label: "FCD CYBER VALLEY", value: 140 },
    { label: "PHD JENGKA", value: 134 },
    { label: "PHD TRIANG", value: 134 },
    { label: "PHD MUADZAM SHAH", value: 134 },
    { label: "PHD BENTONG", value: 134 },
    { label: "PHD RAUB", value: 134 },
    { label: "PHD PEKAN", value: 134 },
    { label: "PHD TAMAN TAS", value: 134 },
    { label: "PHD SRI KEMBANGAN", value: 140 },
    { label: "PHD SRI SERDANG", value: 140 },
    { label: "PHD SRI PETALING", value: 140 },
    { label: "PHD TAMAN PUTRA ", value: 140 },
    { label: "PH AEON KEMPAS", value: 129 },
    { label: "PH AEON TEBRAU", value: 129 },
    { label: "PH BATU PAHAT MALL", value: 129 },
    { label: "PH BUKIT PASIR", value: 129 },
    { label: "PH JLN BAKRI, MUAR", value: 129 },
    { label: "PH JOHOR JAYA", value: 129 },
    { label: "PH MID VALLEY SOUTHKEY", value: 129 },
    { label: "PH MUAR", value: 129 },
    { label: "PH PERMAS JAYA", value: 129 },
    { label: "PH SETIA TROPIKA", value: 129 },
    { label: "PH ROCK ROAD", value: 139 },
    { label: "PH KOTA SENTOSA", value: 139 },
    { label: "PH WISMA SANYAN", value: 139 },
    { label: "PH SING KWONG, SRWK", value: 139 },
    { label: "PH MERDEKA PLAZA", value: 139 },
    { label: "PH KOTA SAMARAHAN", value: 139 },
    { label: "PH BOULEVARD, KUCHING", value: 139 },
    { label: "PH BEAUFORT", value: 138 },
    { label: "PH MEGA LONG", value: 138 },
    { label: "PH KENINGAU", value: 138 },
    { label: "PH TAIPAN INANAM", value: 138 },
    { label: "PH LINTAS PLZ", value: 138 },
    { label: "PH PUTATAN SABAH", value: 138 },
    { label: "PH LABUAN", value: 138 },
    { label: "FCD LABUAN", value: 138 },
    { label: "FCD SENAI AIRPORT", value: 129 },
    { label: "PH IOI MALL KULAI", value: 129 },
    { label: "PH JBCC", value: 129 },
    { label: "PH GALLERIA KOTARAYA 2", value: 129 },
    { label: "PH KSL MALL", value: 129 },
    { label: "PH KULAI 2", value: 129 },
    { label: "PH TERMINAL LARKIN", value: 129 },
    { label: "PHX JPO", value: 129 },
    { label: "PH AEON BUKIT INDAH", value: 129 },
    { label: "PH CAPITAL 21 ", value: 129 },
    { label: "PH DAMANSARA ALIF", value: 129 },
    { label: "PH MUTIARA MAS", value: 129 },
    { label: "PH NUSA BISTARI", value: 129 },
    { label: "PH PARADIGM MALL JB", value: 129 },
    { label: "PH PLAZA ANGSANA", value: 129 },
    { label: "PH PONTIAN", value: 129 },
    { label: "PH TAMAN PERLING 2", value: 129 },
    { label: "PJ JJ TAMAN U", value: 129 },
    { label: "PH BINTANG PLAZA", value: 139 },
    { label: "PH METRO CITY", value: 139 },
    { label: "PH PLZ SARAWAK", value: 139 },
    { label: "PH THE SPRING", value: 139 },
    { label: "PH PERMY JAYA", value: 139 },
    { label: "PH TAMAN SELERA MIRI", value: 139 },
    { label: "PHD AEON BIG FARLIM", value: 135 },
    { label: "PHD BERCHAM", value: 135 },
    { label: "PHD RSA TAPAH", value: 135 },
    { label: "PHD SRI ISKANDAR", value: 135 },
    { label: "PHD TAPAH", value: 135 },
    { label: "PHD SUNGAI BESAR", value: 140 },
    { label: "PHD TANJUNG KARANG", value: 140 },
    { label: "PH TAWAU", value: 138 },
    { label: "PH KUHARA TAWAU", value: 138 },
    { label: "PH CITY MALL KK", value: 138 },
    { label: "PH PLZ JUTA", value: 138 },
    { label: "PH KK TIMES SQUARE", value: 138 },
    { label: "PH SURIA SABAH", value: 138 },
    { label: "PH ARENA TAWAU", value: 138 },
    { label: "PH API - API", value: 138 },
    { label: "PH SEAFEST SQUARE", value: 138 },
    { label: "PH KLANG 2", value: 140 },
    { label: "PH KLANG OCEAN", value: 140 },
    { label: "PH 1 UTAMA", value: 140 },
    { label: "PH SETIA ALAM", value: 140 },
    { label: "PH TELUK PULAI", value: 140 },
    { label: "PH THE CURVE", value: 140 },
    { label: "PH SUBANG 2", value: 140 },
    { label: "PH SRI DAMANSARA", value: 142 },
    { label: "FCD KSL AVENUE,KLANG", value: 142 },
    { label: "PHD BANDAR BARU AMPANG", value: 140 },
    { label: "PHD SELAYANG", value: 140 },
    { label: "PHD SRI GOMBAK", value: 140 },
    { label: "PHD HULU LANGAT", value: 140 },
    { label: "PHD SETIAWANGSA", value: 142 },
    { label: "PHD WANGSA MAJU", value: 142 },
    { label: "PHD DANAU KOTA", value: 142 },
    { label: "FCD SENTUL PERDANA", value: 142 },
    { label: "PH BINTULU", value: 139 },
    { label: "PH BINTULU,TIMES SQUARE", value: 139 },
    { label: "PH TABUAN HEIGHT", value: 139 },
    { label: "PH SATOK", value: 139 },
    { label: "PH BAKO", value: 139 },
    { label: "PH AEON MALL KUCHING SENTRAL", value: 139 },
    { label: "PH TABUAN TRANQUILITY", value: 139 },
    { label: "PHD ALOR SETAR", value: 130 },
    { label: "PHD POKOK SENA", value: 130 },
    { label: "PHD SULTANAH", value: 130 },
    { label: "PHD PENDANG", value: 130 },
    { label: "PHD ARAU", value: 136 },
    { label: "PHD CHANGLUN", value: 130 },
    { label: "PHX UUM SINTOK", value: 130 },
    { label: "PHD KOTA BHARU", value: 131 },
    { label: "PHD KOTA KENANGAN", value: 131 },
    { label: "PHD KUALA KRAI", value: 131 },
    { label: "PHD PASIR PUTEH", value: 131 },
    { label: "PHD MACHANG", value: 131 },
    { label: "PHD PASIR TUMBOH", value: 131 },
    { label: "PHD TUMPAT", value: 131 },
    { label: "PHD BAYAN BARU", value: 137 },
    { label: "PHD VANTAGE POINT", value: 137 },
    { label: "PHD KAMUNTING", value: 135 },
    { label: "PHD BAGAN SERAI", value: 135 },
    { label: "PHD GERIK", value: 135 },
    { label: "PHD SUNGAI SIPUT", value: 135 },
    { label: "PH GUA MUSANG", value: 131 },
    { label: "PH KB MALL", value: 131 },
    { label: "PH KOTA BHARU", value: 131 },
    { label: "PH KUBANG KERIAN", value: 131 },
    { label: "PH TANAH MERAH", value: 131 },
    { label: "PH AEON MALL", value: 131 },
    { label: "PH G-ORANGE", value: 131 },
    { label: "PH KOK LANAS", value: 131 },
    { label: "FCD PENGKALAN CHEPA", value: 131 },
    { label: "PHD BANDAR SRI ALAM", value: 129 },
    { label: "PHD MERSING", value: 129 },
    { label: "PHD PARIT RAJA", value: 129 },
    { label: "PHD ROMPIN", value: 134 },
    { label: "PHD ULU TIRAM", value: 129 },
    { label: "PHD YONG PENG", value: 129 },
    { label: "PHD TAMAN DAYA", value: 129 },
    { label: "PHD BANDAR BUKIT SENTOSA", value: 140 },
    { label: "PHD BATANG KALI", value: 140 },
    { label: "PHD RAWANG 2", value: 140 },
    { label: "PHD SAUJANA UTAMA", value: 140 },
    { label: "PHD DENAI ALAM", value: 140 },
    { label: "FCD BUKIT JELUTONG", value: 140 },
    { label: "PH SEREMBAN PRIMA", value: 133 },
    { label: "PH JUSCO SEREMBAN 2", value: 133 },
    { label: "PH CITY PARK, SEREMBAN", value: 133 },
    { label: "PH PD WATER FRONT", value: 133 },
    { label: "PH PALM MALL", value: 133 },
    { label: "PH SENAWANG", value: 133 },
    { label: "PH BAHAU", value: 133 },
    { label: "PH CENTRE POINT,SEREMBAN", value: 133 },
    { label: "PH ALMA BKT MERTAJAM", value: 137 },
    { label: "PH MEGAMALL PENANG", value: 137 },
    { label: "PH PARIT BUNTAR", value: 135 },
    { label: "PH PAUH JAYA", value: 137 },
    { label: "PH R2 AVENUE", value: 137 },
    { label: "PH TAIPING", value: 135 },
    { label: "PH KUALA KANGSAR", value: 135 },
    { label: "FCD NIBONG TEBAL", value: 137 },
    { label: "FCD KOTA MASAI", value: 129 },
    { label: "PH DESARU", value: 129 },
    { label: "PH KLUANG", value: 129 },
    { label: "PH KLUANG MALL 2", value: 129 },
    { label: "PH KOTA TINGGI", value: 129 },
    { label: "PH PASIR GUDANG", value: 129 },
    { label: "PH PASIR GUDANG 2", value: 129 },
    { label: "PH SEGAMAT", value: 129 },
    { label: "PH TANGKAK JHR", value: 129 },
    { label: "PH TOPPEN MALL", value: 129 },
    { label: "PH BERJAYA TIMES SQUARE", value: 142 },
    { label: "PH PAVILLION 2", value: 142 },
    { label: "PH QUILL CITY MALL", value: 142 },
    { label: "PH SUNWAY VELOCITY ", value: 142 },
    { label: "PH MY TOWN MALL", value: 142 },
    { label: "PH GENTING SKY AVENUE", value: 134 },
    { label: "PH AVENUE K", value: 142 },
    { label: "FCD GURNEY MALL UTMKL", value: 142 },
    { label: "PH BANGI", value: 140 },
    { label: "PH SHAFTBURY", value: 140 },
    { label: "PH PUTRAJAYA, ALAMANDA", value: 144 },
    { label: "PH IOI CITY MALL PUTRAJAYA", value: 144 },
    { label: "PH NILAI", value: 133 },
    { label: "PH SEMENYIH", value: 140 },
    { label: "PH KAJANG 2", value: 140 },
    { label: "PH AEON MALL NILAI", value: 133 },
    { label: "PH KEPONG DRIVE THRU", value: 142 },
    { label: "PH MUTIARA COMPLEX", value: 142 },
    { label: "PH SELAYANG", value: 140 },
    { label: "PH SENTUL RAYA", value: 142 },
    { label: "PH TMN PERMATA", value: 142 },
    { label: "PH TMN MALURI", value: 142 },
    { label: "PH TMN PUTRA", value: 140 },
    { label: "PH MELAWATI MALL", value: 142 },
    { label: "PH BUKIT TINGGI", value: 140 },
    { label: "PH AEON BKT TINGGI KLANG", value: 140 },
    { label: "PH PORT KLANG", value: 140 },
    { label: "PH TMN SENTOSA", value: 140 },
    { label: "PH KAPAR", value: 140 },
    { label: "PH KUALA SELANGOR", value: 140 },
    { label: "PH BANTING", value: 140 },
    { label: "PH GUNUNG RAPAT", value: 135 },
    { label: "PH IPOH CENTRAL", value: 135 },
    { label: "PH IPOH GARDEN", value: 135 },
    { label: "PH IPOH KINTA", value: 135 },
    { label: "PH KELEBANG", value: 135 },
    { label: "PH MERU RAYA", value: 135 },
    { label: "PH AEON STATION 18", value: 135 },
    { label: "PH BATU GAJAH", value: 135 },
    { label: "PHD DAMANSARA DAMAI", value: 140 },
    { label: "PHD DATARAN SUNWAY", value: 140 },
    { label: "PHD MANJALARA", value: 142 },
    { label: "PHD DAMANSARA JAYA", value: 140 },
    { label: "FCD NORTH KIARA", value: 142 },
    { label: "PH CENANG PLAZA", value: 130 },
    { label: "PH JITRA", value: 130 },
    { label: "PH KANGAR", value: 136 },
    { label: "PH KUAH,LANGKAWI", value: 130 },
    { label: "PH LIMBONG KAPAL, ALOR SETAR", value: 130 },
    { label: "PH TESCO MERGONG, AS", value: 130 },
    { label: "PH AMAN CENTRAL", value: 130 },
    { label: "FCD PADANG MAT SIRAT", value: 130 },
    { label: "PHD EXTREME PARK", value: 140 },
    { label: "PHD ALAM AVENUE", value: 140 },
    { label: "PHD BUKIT RIMAU", value: 140 },
    { label: "PHD JENJAROM", value: 140 },
    { label: "PHD BANDAR SAUJANA PUTRA", value: 140 },
    { label: "PHD PUTRA HEIGHT", value: 140 },
    { label: "PHD PUTRAJAYA", value: 144 },
    { label: "PHD PUTRAJAYA PERCINT8", value: 144 },
    { label: "PHD BANDAR MUTIARA", value: 130 },
    { label: "PHD SG PETANI", value: 130 },
    { label: "PHD KEPALA BATAS", value: 137 },
    { label: "PHD BERTAM", value: 137 },
    { label: "PHD GURUN", value: 130 },
    { label: "PHD BUKIT MERTAJAM", value: 137 },
    { label: "PHD SIMPANG AMPAT", value: 137 },
    { label: "PHD DE CENTRUM", value: 133 },
    { label: "PHD SEMENYIH", value: 140 },
    { label: "PHD BANDAR SRI PUTRA", value: 140 },
    { label: "PHD NILAI", value: 133 },
    { label: "PHD BANDAR ENSTEK", value: 133 },
    { label: "PHD GLOMAC KELANA JAYA", value: 140 },
    { label: "PHD ANGGERIK EMAS", value: 129 },
    { label: "PHD SIMPANG RENGGAM", value: 129 },
    { label: "PHD TAMAN CENTURY", value: 129 },
    { label: "PHD KULAI", value: 129 },
    { label: "PHD ALOR GAJAH", value: 132 },
    { label: "PHD BUKIT BERUANG", value: 132 },
    { label: "PHD JASIN", value: 132 },
    { label: "PHD MALIM JAYA", value: 132 },
    { label: "PHD MASJID TANAH", value: 132 },
    { label: "PHD MERLIMAU", value: 132 },
    { label: "PHD SEMABOK", value: 132 },
    { label: "PHD SUNGAI UDANG", value: 132 },
    { label: "PHD TAMAN CHENG", value: 132 },
    { label: "PHD BALAKONG", value: 140 },
    { label: "PHD BDR TUN HUSSEIN ONN", value: 140 },
    { label: "PHD KAJANG", value: 140 },
    { label: "PHD SAUJANA KAJANG", value: 140 },
    { label: "PHD BDR SERI PERMAISURI", value: 142 },
    { label: "PHD TAMAN CONNAUGHT", value: 142 },
    { label: "PHD MELATI UTAMA", value: 142 },
    { label: "FCD SUNGAI LONG", value: 140 },
    { label: "PH PJ NEW TOWN", value: 140 },
    { label: "PH SS 15 SUBANG", value: 140 },
    { label: "PH THE MINES", value: 140 },
    { label: "PH TTDI", value: 142 },
    { label: "PH GIANT KINRARA", value: 140 },
    { label: "PH PARADIGM MALL", value: 140 },
    { label: "PH SEC 14", value: 140 },
    { label: "PH IOI MALL", value: 140 },
    { label: "FCD DA MEN MALL", value: 140 },
    { label: "PH AEON AU2", value: 140 },
    { label: "PH AEON RAWANG", value: 140 },
    { label: "PH GENTING KLANG", value: 142 },
    { label: "PH RAWANG", value: 140 },
    { label: "PH SG BULOH", value: 140 },
    { label: "PH TESCO AMPANG", value: 140 },
    { label: "PH WANGSA MAJU", value: 142 },
    { label: "PH AMPANG POINT", value: 142 },
    { label: "PH SUNWAY PYRAMID", value: 140 },
    { label: "FCD BANDAR TASIK PUTERI", value: 140 },
    { label: "PH BALING", value: 130 },
    { label: "PH GIANT SG PETANI", value: 130 },
    { label: "PH JLN RAJA UDA", value: 137 },
    { label: "PH KULIM", value: 130 },
    { label: "PH LAGENDA VILLAGE", value: 130 },
    { label: "PH LCSC KULIM", value: 130 },
    { label: "PH SUNWAY CARNIVAL", value: 137 },
    { label: "FCD AMAN JAYA", value: 130 },
    { label: "PH BUKIT KEMUNING UTAMA", value: 140 },
    { label: "PH KOTA KEMUNING", value: 140 },
    { label: "PH SA SEC20", value: 140 },
    { label: "PH SEK 7 SHAH ALAM", value: 140 },
    { label: "PH KOTA DAMANSARA", value: 140 },
    { label: "PH I-CITY CENTRAL", value: 140 },
    { label: "PH SHAH ALAM CC", value: 140 },
    { label: "PH TESCO SHAH ALAM", value: 140 },
    { label: "PHD SETIA ALAM", value: 140 },
    { label: "PHD BANDAR BARU KLANG", value: 140 },
    { label: "PHD PANDAMARAN", value: 140 },
    { label: "PHD BANDAR PUTERI KLANG", value: 140 },
    { label: "PHX DE PULZE", value: 140 },
    { label: "PHX GM KLANG 2", value: 140 },
    { label: "PHX VSQ", value: 140 },
    { label: "FCD SECTION 9", value: 140 },
    { label: "PH MALIM JAYA 2", value: 132 },
    { label: "PH BATU BERENDAM", value: 132 },
    { label: "PH AIR KEROH", value: 132 },
    { label: "PH AEON MELAKA", value: 132 },
    { label: "PH MAHKOTA PARADE", value: 132 },
    { label: "PH DIGITAL MALL", value: 132 },
    { label: "PH TAMPIN", value: 133 },
    { label: "PHD KUALA TERENGGANU", value: 141 },
    { label: "PHD PAKA", value: 141 },
    { label: "PHD KUALA BERANG", value: 141 },
    { label: "PHD MARANG", value: 141 },
    { label: "PHD GONG BADAK", value: 141 },
    { label: "PHD INDERA MAHKOTA", value: 134 },
    { label: "PHD BESERAH", value: 134 },
    { label: "FCD BALOK", value: 134 },
    { label: "PHD ARA DAMANSARA", value: 142 },
    { label: "PHD BANGSAR", value: 142 },
    { label: "PHD DAMANSARA HEIGHT", value: 142 },
    { label: "PHD DAMANSARA PERDANA", value: 140 },
    { label: "PHD GEMAS", value: 133 },
    { label: "PHD KUALA PILAH", value: 133 },
    { label: "PHD RASAH JAYA", value: 133 },
    { label: "PHD SENAWANG", value: 133 },
    { label: "PHD SEREMBAN", value: 133 },
    { label: "PH FARLIM 2", value: 137 },
    { label: "PH GIANT BAYAN BARU", value: 137 },
    { label: "PH PERANGIN MALL", value: 137 },
    { label: "PH QUEEN'S BAY MALL", value: 137 },
    { label: "PH SG DUA", value: 137 },
    { label: "PH TANJUNG TOKONG", value: 137 },
    { label: "PH TESCO PENANG", value: 137 },
    { label: "FCD SETIA TRIANGLE", value: 137 },
    { label: "PH DATARAN AUSTIN", value: 141 },
    { label: "PH DUNGUN", value: 141 },
    { label: "PH GIANT K.TERENGGANU", value: 141 },
    { label: "PH KEMAMAN", value: 141 },
    { label: "PH KUALA TERENGGANU", value: 141 },
    { label: "PH MESRA MALL", value: 141 },
    { label: "PH JERTIH", value: 141 },
    { label: "PH BANDAR KIM FUNG", value: 138 },
    { label: "PH GIANT SANDAKAN", value: 138 },
    { label: "PH ONE BORNEO, SBH", value: 138 },
    { label: "PH LAHAD DATU", value: 138 },
    { label: "PH TUARAN BYPASS", value: 138 },
    { label: "PH GAYA STREET", value: 138 },
    { label: "PH PLZ DAMAI", value: 138 },
    { label: "FCD SEJATI WALK", value: 138 }
  ],
  SESSION_KEY_CHECKOUT_INFO: 'PH_CHECKOUT_INFO',
  PAYMENT_METHOD_CACHE: 'PAYMENT_METHOD_CACHE',
  TAKEAWAY: 'takeaway',
  DUPLICATE_FRIENDLY_NAME_SEO: 46
}



// WEBPACK FOOTER //
// ./src/constants.js